import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const profileServiceApi = createApi({
  reducerPath: 'profileServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Profile'],
  endpoints: (builder) => ({
    // Current authenticated user
    getMe: builder.query({
      query: () => 'auth/me',
      providesTags: ['Profile'],
    }),
    // Update firstname / lastname / avatar (multipart form-data)
    updateProfile: builder.mutation({
      query: ({ firstname, lastname, avatar }) => {
        const formData = new FormData()
        if (firstname !== undefined) formData.append('firstname', firstname)
        if (lastname !== undefined) formData.append('lastname', lastname)
        if (avatar) formData.append('avatar', avatar)
        return {
          url: 'frontoffice/profile',
          method: 'PUT',
          body: formData,
        }
      },
      invalidatesTags: ['Profile'],
    }),
    // Change the current user's password
    changePassword: builder.mutation({
      query: (payload) => ({
        url: 'frontoffice/profile/password',
        method: 'PATCH',
        body: payload,
      }),
    }),
  }),
})

export const { useGetMeQuery, useUpdateProfileMutation, useChangePasswordMutation } =
  profileServiceApi
